/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown> }} Spellcheck_In_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Spell check in progress: {progress}%" |
*
* @param {Spellcheck_In_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_in_progress_label = /** @type {((inputs: Spellcheck_In_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_In_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Verification orthographique en cours : ${i?.progress}%`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Rechtschreibprüfung läuft: ${i?.progress}%`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Controllo ortografico in corso: ${i?.progress}%`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Идет проверка орфографии: ${i?.progress}%`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Revisión ortográfica en curso: ${i?.progress}%`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`拼写检查进行中：${i?.progress}%`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スペルチェック中: ${i?.progress}%`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वर्तनी जाँच जारी है: ${i?.progress}%`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Verificação ortográfica em andamento: ${i?.progress}%`)
	return /** @type {LocalizedString} */ (`Spell check in progress: ${i?.progress}%`)
});